import dynamic from "next/dynamic";
import { useMemo } from "react";

import { WholePageLoading } from "components/Loading";
import { useGetEvaluationDataFromLocalStorageQuery } from "src/hooks";
import { checkCountry } from "src/utils/checkCountry";

import { EvalIds, RegionType } from "../../graphql/generated";
import { GetStarted } from "./GetStarted";
import useEvaluationFlow from "./hooks/useEvaluationFlow";

const Evaluation = dynamic(() =>
  import("./Evaluation").then((components) => components.Evaluation)
);
const ConsultTypeSelectorContainer = dynamic(() =>
  import("./ConsultTypeSelectorContainer").then(
    (components) => components.ConsultTypeSelectorContainer
  )
);

type Props = {
  evaluationId: EvalIds;
  productId: string;
};
export const EvaluationFlow = ({ evaluationId, productId }: Props) => {
  const isRequiredConsultType = useMemo(() => {
    return (
      [
        EvalIds.Ed,
        EvalIds.Pe,
        EvalIds.Hairloss,
        EvalIds.WeightLoss,
        EvalIds.WeightLossZoey
      ].includes(evaluationId) && checkCountry([RegionType.Jp, RegionType.Hk])
    );
  }, [evaluationId]);

  const { data: localEvalData } = useGetEvaluationDataFromLocalStorageQuery(evaluationId);

  const {
    isShowConsultType,
    isShowEval,
    consultType,
    setNextEvalStep,
    setConsultType,
    showEvalFlow,
    hideEvalFlow,
    clickBackFromSelectConsult,
    isGuest
  } = useEvaluationFlow({
    isRequiredConsultType,
    latestQuestionId: localEvalData?.latestQuestionSysId,
    evaluationId
  });

  if (isGuest) return <WholePageLoading />;

  if (isShowConsultType) {
    return (
      <ConsultTypeSelectorContainer
        onSelectType={setConsultType}
        consultType={consultType}
        onNextClick={showEvalFlow}
        onClickBack={clickBackFromSelectConsult}
        shouldShowMoreInit={false}
      />
    );
  }

  if (isShowEval) {
    return (
      <Evaluation
        hideEvalFlow={hideEvalFlow}
        consultType={consultType}
        evaluationId={evaluationId}
        productId={productId}
      />
    );
  }

  return <GetStarted evaluationId={evaluationId} onClick={setNextEvalStep} />;
};
